import {Button} from '../Button'
import {Headline} from '../Headline'
import {Dialog} from './Dialog'

export interface DialogExternalLinkProps {
  hostname?: string
  title?: string
  text?: string
  buttonText?: string
  link?: string
}

export const DialogExternalLink = ({hostname, title, link, text, buttonText}: DialogExternalLinkProps) => (
  <Dialog.Section className={'h-full'}>
    {hostname && <p className={'text-sm font-thin'}>{hostname}</p>}
    {title && (
      <Headline
        tag={'h3'}
        size={5}
        className={'py-2 font-normal'}
      >
        {title}
      </Headline>
    )}
    <p className={'py-2 text-sm font-thin'}>{text}</p>
    <div className={'py-4'}>
      <Button
        size={'small'}
        onClick={() => window.open(link, '_blank', 'noopener noreferrer')}
      >
        {buttonText}
      </Button>
    </div>
    <a
      href={link}
      target={'_blank'}
      rel={'noopener noreferrer'}
    >
      {link}
    </a>
  </Dialog.Section>
)
